import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { GlobalService } from '../global/global.service';

@Injectable()
export class PolicyService {

  constructor(private http: HttpClient, private globalService: GlobalService) {
  }
  //url = this.globalService.urlMiPortal();

  getToken() {
    return localStorage.getItem('key'); //token
  }

  public PrivacyPolicy(): Observable<any> {
    //TODO GS
    // tslint:disable-next-line:max-line-length
    // return this.http.post<any>(this.url + 'Home/PrivacyPolicy', '')
    //   .catch(error => {
    //     return Observable.throw('An error occurred:', error.message);
    //   });
    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/policy/policy.service.ts